import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GenericStatusLoading from 'components/GenericStatusLoading'
import styles from './styles.scss'
import { submitLead } from './actions'

class SubmitStage extends PureComponent {
  static propTypes = {
    // From Wagtail
    loadingMessage: PropTypes.string,

    // Redux functions
    submitLead: PropTypes.func,
  }

  static defaultProps = {
    loadingMessage: '<h3>Finalising your order</h3>',
    submitLead: f => f,
  }

  componentDidMount() {
    this.props.submitLead()
  }

  render() {
    const {
      loadingMessage,
    } = this.props

    return (
      <div className={styles.loadingWrapper}>
        <GenericStatusLoading extraClassName={styles.loader} />
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: loadingMessage }}
        />
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLead,
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitStage)



// WEBPACK FOOTER //
// ./containers/stages/SubmitStage/index.jsx